import Component from './Component';
import React from 'react';
import immutable from 'immutable';
import classNames from 'classnames';

export default class WeekScheduler extends Component {

	constructor(props) {
		super(props);
	}

	getMatrix() {
		let m = immutable.Map();
		for (let i = 0; i < 24; i++) {
			let x = i % 8;
			let y = Math.floor(i / 8);
			if (this.props.value && this.props.value.indexOf(i) !== -1) {
				m = m.setIn([x.toString(), y.toString()], true);
			}
		}
		return m;
	}

	matrix2List(data) {
		let list = immutable.List();
		for (let i = 0; i < 3; i++) {
			for (let j = 0; j < 8; j++) {
				const hour = i * 8 + j;
				if (data.getIn([j.toString(), i.toString()])) {
					list = list.push(hour);
				}
			}
		}
		return list;
	}

	handleChange(val) {
		this.props.onChange(val);
	}

	handleClick(i, j) {
		const data = this.getMatrix();
		const value = data.getIn([j.toString(), i.toString()]);
		if (!data[i]) {
			data[i] = {};
		}
		const nd = data.setIn([j.toString(), i.toString()], !value);
		this.handleChange(this.matrix2List(nd));
	}

	handleMouseDown(i, j) {
		this.mouseDown = true;
		this.start = this.getMatrix();
		this.startXY = [i, j];
	}

	handleMouseUp() {
		this.mouseDown = false;
	}

	handleMouseMove(i, j) {
		if(this.mouseDown) {
			const rect1 = [this.startXY[0] < i ? this.startXY[0] : i, this.startXY[1] < j ? this.startXY[1] : j];
			const rect2 = [this.startXY[0] > i ? this.startXY[0] : i, this.startXY[1] > j ? this.startXY[1] : j];

			let nd = this.start;
			for (let i = rect1[0]; i <= rect2[0]; i++) {
				for (let j = rect1[1]; j <= rect2[1]; j++) {
					const value = nd.getIn([j.toString(), i.toString()]);
					nd = nd.setIn([j.toString(), i.toString()], !value);
				}
			}
			this.handleChange(this.matrix2List(nd));
		}
	}

	render() {
		const hours = [];
		const data = this.getMatrix();
		for (let i = 0; i < 3; i++) {
			const tr = [];
			for (let j = 0; j < 8; j++) {
				const hour = i * 8 + j;
				tr.push(<td onMouseDown={() => this.handleMouseDown(i, j)}
							onMouseUp={() => this.handleMouseUp(i, j)}
							onMouseMove={() => this.handleMouseMove(i, j)}
							onClick={() => this.handleClick(i, j)}
							style={{width: 60, height: 30, textAlign:'center'}}
							className={classNames({selected: data.getIn([j.toString(), i.toString()])})}>{hour}:00</td>);
			}
			hours.push(<tr>{tr}</tr>)
		}

		return (
			<div style={{marginBottom: 10}}>
				<table className="scheduler noselect" onMouseLeave={() => this.handleMouseUp()}>
					<tbody>
						{hours}
					</tbody>
				</table>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/WeekScheduler.js